import m from "./design-system.es58.js";
import { resolveComponent as f, openBlock as a, createBlock as h, resolveDynamicComponent as p, mergeProps as k, withCtx as _, createElementBlock as s, renderSlot as i, createVNode as u, createCommentVNode as c, createTextVNode as g } from "vue";
/* empty css                    */
import I from "./design-system.es128.js";
const y = {
  name: "DsLink",
  components: { Icon: m },
  props: {
    /**
     * Controls which element to render
     */
    as: {
      type: String,
      default: "a",
      validator: (e) => ["a", "button"].includes(e)
    },
    /**
     * Opens link in new window with security protections
     */
    external: Boolean,
    /**
     * URL or other valid path to visit when clicked
     */
    href: String,
    /**
     * Name of the icon to render in the leading slot.
     */
    leadingIcon: String,
    /**
     * Includes external link icon by default, or given icon.
     */
    trailingIcon: String,
    /**
     * Defines the button type when component is rendered as button
     */
    type: String
  },
  computed: {
    attributes() {
      const {
        as: e,
        external: t,
        href: n,
        type: o,
        $attrs: l
      } = this;
      return e === "button" ? {
        ...l,
        type: o === void 0 ? "button" : o || null
      } : {
        ...l,
        target: t ? "_blank" : null,
        rel: t ? "noopener noreferrer" : null,
        href: n
      };
    },
    hasLeading() {
      return this.$slots.leading || this.leadingIcon;
    },
    hasTrailing() {
      return this.$slots.trailing || this.trailingIcon;
    }
  }
}, b = {
  key: 0,
  class: "leading"
}, v = { key: 1 }, S = {
  key: 3,
  class: "trailing"
};
function L(e, t, n, o, l, r) {
  const d = f("Icon");
  return a(), h(p(n.as), k(r.attributes, { class: "link ds-link" }), {
    default: _(() => [
      r.hasLeading ? (a(), s("div", b, [
        i(e.$slots, "leading", {}, () => [
          u(d, { name: n.leadingIcon }, null, 8, ["name"])
        ], !0)
      ])) : c("", !0),
      t[0] || (t[0] = g()),
      r.hasLeading || r.hasTrailing ? (a(), s("div", v, [
        i(e.$slots, "default", {}, void 0, !0)
      ])) : i(e.$slots, "default", { key: 2 }, void 0, !0),
      t[1] || (t[1] = g()),
      r.hasTrailing ? (a(), s("div", S, [
        i(e.$slots, "trailing", {}, () => [
          u(d, { name: n.trailingIcon }, null, 8, ["name"])
        ], !0)
      ])) : c("", !0)
    ]),
    _: 3
  }, 16);
}
const N = /* @__PURE__ */ I(y, [["render", L], ["__scopeId", "data-v-b3f97e90"]]);
export {
  N as default
};
//# sourceMappingURL=design-system.es66.js.map
